import { magic } from '../lib/magic';

export const handleMagicLinkError = (error) => {
  // Categorize different types of errors
  if (error.code === 'USER_DENIED_ACCESS') {
    return {
      type: 'user_cancelled',
      message: 'Login was cancelled by the user'
    };
  } else if (error.code === 'INVALID_ARGUMENT') {
    return {
      type: 'invalid_config',
      message: 'Invalid configuration. Please try again.'
    };
  } else if (error.code === 'NETWORK_ERROR') {
    return {
      type: 'network_error',
      message: 'Network error. Please check your connection and try again.'
    };
  } else if (error.message?.includes('timeout')) {
    return {
      type: 'timeout',
      message: 'Request timed out. Please try again.'
    };
  } else {
    return {
      type: 'unknown',
      message: 'An unexpected error occurred. Please try again.'
    };
  }
};

export const isMagicLinkRedirect = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  const hasMagicCredential = urlParams.has('magic_credential');
  const hasState = urlParams.has('state');
  const hasOauthRedirect = localStorage.getItem('isOauthRedirect') === 'true';
  
  return hasMagicCredential || hasState || hasOauthRedirect;
};

export const clearMagicLinkState = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('isOauthRedirect');
    
    // Clear any magic link related URL parameters
    const url = new URL(window.location);
    url.searchParams.delete('magic_credential');
    url.searchParams.delete('state');
    window.history.replaceState({}, '', url.toString());
  }
};

export const validateMagicLinkResult = (result) => {
  if (!result) {
    return false;
  }
  
  // Check if we have the required data
  const hasUserMetadata = !!result?.magic?.userMetadata;
  const hasIdToken = !!result?.magic?.idToken;
  const hasAccessToken = !!result?.oauth?.accessToken;
  
  return hasUserMetadata && hasIdToken && hasAccessToken;
}; 